export {createProductPath} from "./productPath";

export function getFirstProductImageData(product: any) {
    return product?.localImages
        ?.find((image: any) => image?.childImageSharp?.gatsbyImageData)
        ?.childImageSharp?.gatsbyImageData;
}
